import type { PropsWithChildren } from "react";

export default function BulletListItem({ children }: PropsWithChildren) {
  return <>{children}</>;
}
